<template>
  <div class="fileItem">
    <div v-if="file.version" class="version">{{file.version}}</div>
    <fileIcon :mime="file.fileContentType" />
    <div class="info">
      <div class="title">{{file.fileName}}</div>
      <div class="author">
        <div>{{fileSize}}</div>
        <div>{{time}}</div>
        <div>{{username}}</div>
      </div>
    </div>
    <div class="opt">
      <template v-if="!disabled">
        <div class="a" v-if="(isRight && !isVersion)" @click="handleEdit">编辑</div>
        <div v-if="isRight && !isVersion">/</div>
        <div class="a" v-if="isRight" @click="handleView">预览</div>
        <div v-if="isRight">/</div>
        <div class="a" v-if="isRight && !isVersion" @click="handleVersion">历史版本</div>
        <div v-if="isRight && !isVersion">/</div>
        <div class="a" @click="handleDownload">下载</div>
        <div v-if="!isVersion">/</div>
        <div v-if="!isVersion" class="a" @click="handleDelete">删除</div>
      </template>
      <template v-else>
        <div class="a" v-if="isRight" @click="handleView">预览</div>
        <div v-if="isRight">/</div>
        <div class="a" v-if="isRight && !isVersion" @click="handleVersion">历史版本</div>
        <div v-if="isRight && !isVersion">/</div>
        <div class="a" @click="handleDownload">下载</div>
      </template>
    </div>
  </div>
</template>

<script>
// import moment from 'moment'
import { file } from 'vue-gulp/dist'
import { isWPS } from './wps'
import _ from 'lodash'
// moment.locale('zh-cn')
export default {
  props: {
    file: {
      type: Object,
      default: () => {}
    },
    isVersion: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    fileIcon: () => import('./fileIcon.vue')
  },
  data() {
    // time = moment(time).fromNow()
    return {
    }
  },
  computed: {
    fileSize() {
      return file.formatSize(this.file.fileSize)
    },
    time() {
      const {
        createTime,
        modifyTime
      } = this.file
      let time = createTime
      if (modifyTime) {
        time = modifyTime
      }
      return time
    },
    username() {
      const {
        createUserName,
        modifyUserName
      } = this.file

      let username = createUserName

      if (modifyUserName) {
        username = modifyUserName
      }
      return username
    },
    isRight() {
      const {
        fileName
      } = this.file

      const arr = _.split(fileName, '.')
      return isWPS(arr[arr.length - 1])
    }
  },
  methods: {
    handleEdit(e) {
      this.$emit('on-edit', this.file)
    },
    handleView(e) {
      this.$emit('on-view', this.file)
    },
    handleVersion(e) {
      this.$emit('on-version', this.file)
    },
    handleDownload(e) {
      this.$emit('on-down', this.file)
    },
    handleDelete(e) {
      this.$emit('on-delete', this.file)
    }
  }
}
</script>

<style lang="scss" scoped>
.fileItem {
  display: flex;
  padding: 12px 20px;
  box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  line-height: 1rem;
  .version {
    display: flex;
    align-items: center;
    padding-right: 12px;
    color: gray;
  }
  .info {
    flex: 1;
    padding-left: 12px;
    .title {
      font-weight: 600;
      padding-bottom: 7px;
      width: 100%;
    }
    .author {
      display: flex;
      align-items: center;
      color: gray;
      font-size: 12px;
      div {
        padding:0 2px;
      }
    }
  }
  .opt {
    display: flex;
    font-size: 12px;
    align-items: center;
    div {
      padding: 0 2px;
    }
    .a:hover {
      cursor: pointer;
      color: #409EFF;
    }
  }
}
</style>
